import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';

import {fuseAnimations} from '@fuse/animations';
import {AlertService} from "../../../services";
import {DeleteMenuDialogComponent} from "../../../cms/menu/dialog/deleteMenuDialog.component";
import {FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {CreateCashReportItemDialogComponent} from "../../dialog/createCashReportItemDialog.component";
import {CashReportItemService} from "../../service/cashReportItem.service";
import {CashReport} from "../../model/cashReport";
import {CloseCashReportDialogComponent} from "../../dialog/closeCashReportDialog.component";
import {CashReportService} from "../../service/cashReport.service";
import {OpenCashReportDialogComponent} from "../../dialog/openCashReportDialog.component";

@Component({
    selector: 'cash-report-main-sidebar',
    templateUrl: './main-sidebar.component.html',
    styleUrls: ['./main-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CashReportMainSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    loadingIndicator: boolean;
    createCashReportItemDialogRef: any;
    closeCashReportDialogRef: any;
    openCashReportDialogRef: any;
    activeCashReport: CashReport|null;
    lastCashReport: CashReport|null;
    processing = false;

    // Private
    private _unsubscribeAll: Subject<any>;


    constructor(
        private _router: Router,
        private alertService: AlertService,
        public _matDialog: MatDialog,
        private cashReportItemService: CashReportItemService,
        private cashReportService: CashReportService,
        private route: ActivatedRoute,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;

        this.activeCashReport = this.route.snapshot.data.activeCashReport;
        this.lastCashReport = this.route.snapshot.data.lastCashReport;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New cash report item
     */
    newCashReportItem(income: boolean): void {
        this.createCashReportItemDialogRef = this._matDialog.open(CreateCashReportItemDialogComponent, {
            panelClass: 'create-cash-report-item-dialog',
            data      : {
                action : 'show',
                income: income,
            },
            width: '450px',
        });

        this.createCashReportItemDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.processing = true;

                if (!response.value.outcome) {
                    response.value.outcome = 0;
                } else {
                    response.value.income = 0;
                }

                this.cashReportItemService.create(response.value).pipe(first())
                    .subscribe(res => {
                        this.processing = false;
                        window.location.reload();
                    }, error => {
                        this.processing = false;
                    });

                this.createCashReportItemDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    openCashReport(lastCashReport: CashReport): void {
        this.openCashReportDialogRef = this._matDialog.open(OpenCashReportDialogComponent, {
            panelClass: 'open-cash-report-dialog',
            data      : {
                action : 'show',
                lastCashReport: lastCashReport,
            },
            width: '600px',
        });

        this.openCashReportDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.processing = true;

                const openDayCash = response.value.openDayCash;
                const comments = response.value.comments;

                this.cashReportService.open(this.activeCashReport, openDayCash, comments).pipe(first())
                    .subscribe(res => {
                        this.processing = false;
                        window.location.reload();
                    }, error => {
                        this.processing = false;
                    });

                this.openCashReportDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    closeCashReport(activeCashReport: CashReport): void {
        this.closeCashReportDialogRef = this._matDialog.open(CloseCashReportDialogComponent, {
            panelClass: 'close-cash-report-dialog',
            data      : {
                action : 'show',
                activeCashReport: activeCashReport,
            },
            width: '600px',
        });

        this.closeCashReportDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.processing = true;

                const endDAyCash = response.value.endDayCash;
                const comments = response.value.comments;

                this.cashReportService.close(this.activeCashReport, endDAyCash, comments).pipe(first())
                    .subscribe(res => {
                        this.processing = false;
                        window.location.reload();
                    }, error => {
                        this.processing = false;
                    });

                this.closeCashReportDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
